import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
  return request({
    url: "/base/passCheck/findByPage",
    method: "post",
    data
  });
}

/**
 * 获取列表数据
 * @param {*} data
 */
export function SavePassCheck(data) {
  return request({
    url: "/base/passCheck/savePassCheck",
    method: "post",
    data
  });
}
/**
 * 删除记录
 * @param {*} data
 */
export function DeleteDataById(data) {
  return request({
    url: "/base/passCheck/deletePassCheckByIds",
    method: "post",
    data
  });
}
/**
 * 根据id获取单条信息
 * @param {*} data
 */
export function FetchFindById(data) {
  return request({
    url: "/base/passCheck/findPassCheckById",
    method: "post",
    data
  });
}





